export default "__VITE_ASSET__ecn8D79w__"